import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PointsExpirationsRoutes: Routes = [
  {
    path: "points-expiration",
    loadComponent: () =>
      import("./points-expiration/points-expiration.component").then(
        (m) => m.PointsExpirationsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./points-expiration-list/points-expiration-list.component").then(
            (m) => m.PointsExpirationListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./points-expiration-form/points-expiration-form.component").then(
            (m) => m.PointsExpirationFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./points-expiration-form/points-expiration-form.component").then(
            (m) => m.PointsExpirationFormComponent,
          ),
      },
    ],
  },
];
